import { COLLECTIONS } from "constants/action-types";
import { EventTypes } from "redux-segment";

export const fetchCollectionPOIs = (collectionId, nextPage = false) => ({
    meta: {
        analytics: EventTypes.track,
    },
    payload: { collectionId, nextPage },
    type: COLLECTIONS.COLLECTION.POIS.FETCH.START,
});

export const fetchCollectionPOI = (collectionId, collectionPoiId) => {
    return {
        meta: {
            analytics: EventTypes.track,
        },
        payload: { collectionId, collectionPoiId },
        type: COLLECTIONS.COLLECTION.POI.FETCH,
    };
};
